import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import messages from './WatercraftDetailsComponent.messages';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './WatercraftDetailsComponent.metadata.json5';

function WatercraftDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated,} = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('WatercraftDetailsComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const { showConfirm } = useModal();

    modelVM.value.isValidationReq = true;

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const deleteWatercraftDetails = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.perUmbLiaCoverable.watercraftDetails.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        priPolLimFie: {
            defaultValue: '1000000'
        } 
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteWatercraftDetails
        },
        resolveClassNameMap: styles
    };


    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

WatercraftDetailsComponent.propTypes = wizardProps;
export default withRouter(WatercraftDetailsComponent);
